module.exports = __webpack_public_path__ + "img/ja_jp.39510836.png";